import { IVirtualCounter } from './types'
import { CostsAndCO2Panel, VirtualCounterCostsAndCO2Panel } from '../BaseCounter/CostsAndCO2Panel'
import { BarChartDay } from '../../../components/EnergyBarCharts'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { useGetMediumColor } from '../../../hooks/useGetMediumColor'
import { HiOutlineCalculator } from 'react-icons/hi2'
import { themedUseStyletron } from '../../../theme/customTheme'

export function OverviewPanel(props: IVirtualCounter) {
    //const [color] = useGetMeasurmentColor(props.dimension);
    const [color] = useGetMediumColor(props.counterMedium, props.counterType);
    const [css, theme] = themedUseStyletron();

    return (
        <OverviewPanelWrapper height={theme.appSizes.mediumAppHeight} icon={<HiOutlineCalculator size="100%"></HiOutlineCalculator>} {...props}>
            <>
                <VirtualCounterCostsAndCO2Panel currencyCode={props.currencyCode} id={props.id} resourceGroupId={props.resourceGroupId} counterType={props.counterType} dimension={props.dimension} days={7}></VirtualCounterCostsAndCO2Panel>
                <div className={css({ height: '220px', width: '100%' })}>
                    <BarChartDay resourceGroupId={props.resourceGroupId} showTimeNavigation={false} color={color} responsive={true} id={props.id} ></BarChartDay>
                </div>
            </>
        </OverviewPanelWrapper>
    );
}